angular.module('user')
    .controller('LogoutModalController', ['$scope', function($scope) {
        var vm = this;

        vm.cancelAction = function() {
            $scope.dismissThisDialog();
        };
        vm.confirmAction = function() {
            $scope.closeThisDialog();
        };
    }]);
